<div class="ch-panel-content d-flex flex-column">
  <h3>Initial Client Tasks</h3>
  <p>
    These client task(s) are automatically added when a new client workspace is
    created
  </p>
  <div
    class="tracked-item-dashboard-wapper"
    [ngClass]="{ 'd-flex': templates.length == 0 }"
  >
    <div
      class="d-flex align-items-center"
      *ngIf="active_template['tracked_items']?.length == 0"
    >
      <div
        style="padding: 0 20px; width: 650px; max-width: 100%"
        class="text-center"
      >
        <h4>You have no client tasks</h4>
        <p>
          To create default client tasks, click the button edit, Lorem ipsum
          dolor sit amet consectetur adipisicing elit. Aut ipsum corporis qui
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Error et.
        </p>
      </div>
    </div>
    <div class="row" *ngIf="templates.length > 0">
      <!-- <div class="col-sm-4 col-lg-3 border-right">
        <div class="clients-list scrollable">
          <div
            *ngFor="let template of templates"
            (click)="selectTemplate(template)"
          >
            <a
              class="clients-list-item"
              [ngClass]="{ active: active_template.id == template.id }"
            >
              <div class="clients-list-name">{{ template.name }}</div>
            </a>
          </div>
        </div>
      </div> -->
      <div
        class="col-sm-8 col-lg-9"
        *ngIf="active_template['tracked_items']?.length > 0"
      >
        <div class="tracked-item-template-bg">
          <div class="row modal-row d-flex">
            <div
              class="col-sm-8 col-md-7 left-column"
              #scrollMe
              [scrollTop]="scrollMe.scrollHeight"
            >
              <div
                class="tracked-items-preview tracked-items-template scrollbars"
              >
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-8">
                      <h3>{{ active_template.name }}</h3>
                      <!-- <input
                        type="text"
                        class="form-control"
                        placeholder="Template name"
                        [(ngModel)]="active_template.name"
                        autofocus
                      /> -->
                    </div>
                    <!-- <div class="col-md-4">
                      <button
                        (click)="updateTrackedItemsTemplate()"
                        class="btn btn-primary btn-block"
                        style="padding: 9px 16px"
                      >
                        Save Name
                      </button>
                    </div> -->
                  </div>
                </div>
                <div class="request-header">
                  <label class="h4 m-0"
                    ><i class="feather card-view"></i> &nbsp;<span class="bold"
                      >Preview</span
                    ></label
                  >
                  <button
                    (click)="openEditModal()"
                    class="btn btn-primary"
                    style="margin-left: 15px"
                  >
                    Edit
                  </button>
                </div>

                <div
                  class="message-bubble tracked-item created"
                  *ngFor="let tracked_item of active_template.tracked_items"
                >
                  <tracked-item-bubble
                    class="no-hover template-manager"
                    [tracked_item]="tracked_item"
                    [user]="user"
                    [conversation]="{ id: 0 }"
                    [isTemplateManager]="true"
                  >
                  </tracked-item-bubble>
                </div>

                <!-- <button
                  (click)="deleteTrackedItemsTemplate()"
                  class="btn btn-danger"
                  style="margin-top: 20px; margin-bottom: 100px"
                >
                  Delete Template
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
